import { createReducer, on } from '@ngrx/store';
import { initialEditingTextState } from '../State/editingTexteState';
import { setEditingTextInputs } from '../Actions/editingTexte.actions';


export const editingTextReducer = createReducer(
  initialEditingTextState,
  on(setEditingTextInputs, (state, { inputs }) => ({
    ...state,
    ...inputs
  })));    